import { SearchErrors } from "@/typings/ErrorStates";
import Error from "./Error";
import triangle from "@/icons/exclamation-triangle.svg";
import circle from "@/icons/circle-exclamation.svg";
import { dispatchCustomEvent } from "@/helpers/triggerAnalyticsEvent";

function  setURLParams() {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete("q");
  urlParams.set("expanded","true");
  history.pushState(
    null,
    "",
    `${window.location.pathname}?${urlParams.toString()}#examples`
  );
}

const ErrorBlock = ({ error, handlePrompt = () => {}, onSearchSubmit = () => {} }: { error: SearchErrors;handlePrompt?: (query: string) => void;  onSearchSubmit?: (query: boolean) => void; }) => {

  switch (error) {
    case SearchErrors.Unknown:
      return (
        <Error
          thumbnail={"/sites/syc/img/unknown_error.png"}
          iconSource={circle}
          title="There was an unknown error in your search."
          description="Sometimes this happens
        when our connection is busy or we're not able to provide results."
          helper="   Try your search again or come back later."
          showSamples
          handlePrompt={handlePrompt}
          onSearchSubmit={onSearchSubmit} 
        />
      );
    case SearchErrors.TooLong:
      return (
        <Error
          thumbnail={"/sites/syc/img/max_char_error.png"}
          iconSource={triangle}
          title="Woah! I can’t handle that many words yet."
          description="Your search has too many characters for us to handle right now."
          helper="Please try your search again using less words."
          showSamples
          handlePrompt={handlePrompt}
          onSearchSubmit={onSearchSubmit} 
        />
      );
    case SearchErrors.NeedDetails: {
      const handleClick = () => {
        dispatchCustomEvent({
          dataObject: "error-block",
          dataType: "button",
          dataReason: "see-examples",
        });
        setURLParams();
        onSearchSubmit(false);
      };

      return (
        <Error
          thumbnail={"/sites/syc/img/more_detail_error.avif"}
          iconSource={triangle}
          title="More detail or inspiration can help your search."
          description={
            <span>
              Your search works better when you include words like “inspired”
              by or products “in the style of”.{" "}
              <button
                onClick={handleClick}
                className="syfclickevent font-bold text-syfGreen"
                data-object="error-block"
                data-type="button"
                data-reason="see-examples"
              >
                See Examples
              </button>
            </span>
          }
          helper="Please try your search again using more words."
          showSamples
          handlePrompt={handlePrompt}
          onSearchSubmit={onSearchSubmit} 
        />
      );
    }

    case SearchErrors.RateLimit:
      return (
        <Error
          thumbnail={"/sites/syc/img/rate_limit_error.png"}
          iconSource={triangle}
          title="Sorry, we’ve reached a search limit for now"
          description="We have reached a daily limit on the number of searches we can provide.

      You can try again soon."
          helper="You can try again soon."
          handlePrompt={handlePrompt}
          onSearchSubmit={onSearchSubmit} 
        />
      );
    case SearchErrors.Sensitive:
      return (
        <Error
          thumbnail={"/sites/syc/img/sensitive_content_error.png"}
          iconSource={triangle}
          title="Oops!"
          description={
            <span>
              Your search might lead us into some sensitive territory. See our{" "}
              <a
                href="https://www.synchrony.com/legal/terms-of-use"
                target="_blank"
                className=" font-bold text-syfGreen"
              >
                Terms of Use.
              </a>
            </span>
          }
          helper="Please try again."
          showSamples
          handlePrompt={handlePrompt}
          onSearchSubmit={onSearchSubmit} 
        />
      );
    case SearchErrors.NoResults:
      return (
        <Error
          thumbnail={"/sites/syc/img/no_results_error.png"}
          iconSource={circle}
          title="We’ve looked all over and just can’t find any products."
          description="We searched our Partner Brands and just can’t retrieve any products that match your prompt."
          helper=""
          showSamples
          handlePrompt={handlePrompt}
          onSearchSubmit={onSearchSubmit} 
        />
      );

    default:
      return null;
  }
};

export default ErrorBlock;
